<template>
  <b-card title="افزودن اشتراک جدید">
    <b-form >
      <b-row>
        <b-col cols="6">
          <!-- title-->
          <b-form-group
              label="*عنوان اشتراک"
          >
            <b-form-input
                id="v-category-name"
                placeholder="عنوان اشتراک را وارد کنید"
                v-model="postData.title"
            />
          </b-form-group>


          <!--numberOfDevice-->
          <b-form-group
              label="*تعداد دستگاه ها"
          >
<!--            <b-form-input-->
<!--                placeholder="تعداد دستگاهایی میخواهید در این اشتراک فعال باشد را وارد کنید"-->
<!--                v-model="postData.numberOfDevice"    type="number"-->
<!--            />-->

            <b-form-radio
                v-model="postData.numberOfDevice"
                plain
                name="some-radios3"
                value="1"
            >
              1
            </b-form-radio>
            <b-form-radio
                v-model="postData.numberOfDevice"
                plain
                name="some-radios3"
                value="2"
            >
              2
            </b-form-radio>
            <b-form-radio
                v-model="postData.numberOfDevice"
                plain
                name="some-radios3"
                value="3"
            >
              3
            </b-form-radio>
          </b-form-group>

          <b-form-group
              label="*مدت زمان اشتراک"
          >
            <b-form-input
                placeholder="مدت زمان اشتراک را به صورت ماهانه وارد کنید"
                v-model="postData.expireMonths" type="number"

            />



          </b-form-group>


          <!--numberOfDevice-->
          <b-form-group
              label="*قیمت"
          >
            <b-form-input
                placeholder="قیمت اشتراک را وارد کنید"
                v-model="postData.price" type="number"
            />
          </b-form-group>

          <b-form-group
              label="درصد تخفیف"
          >
            <b-form-input
                placeholder="درصد تخفیف را وارد کنید"
                v-model="postData.discountPercent" type="number"
            />
          </b-form-group>

        </b-col>
        <b-col cols="6" >


          <img src="../../../assets/images/subscription.png" >

        </b-col>


        <b-col cols="12">
          <b-button
              v-ripple.400="'rgba(255, 255, 255, 0.15)'"
              class="mr-1"
              @click="addSubscription"
              variant="success"
          >
            ثبت
          </b-button>
        </b-col>
      </b-row>
    </b-form>
  </b-card>
</template>

<script>
import {
  BButton,
  BCol,
  BFormFile,
  BForm,
  BFormCheckbox,
  BImg,
  BFormSelect,
  BFormGroup,
  BCardTitle,
  BCardSubTitle,
  BCardText,
  BFormInput,
  BFormRadio,
  BLink,
  BCard,
  BRow,
  BCardBody
} from "bootstrap-vue";
import Croppa from 'vue-croppa'
import Vue from "vue";
import categoryRepository from "@/modules/categories/services/categoryRepository";
import axios from "@/libs/axios";
import Swal from 'sweetalert2'
import {$themeConfig} from "@themeConfig";
import uploadService from "@/modules/services/uploadService";
import videoFormComponent from "@/modules/contents/add/videoFormComponent";
import Image from "@/views/components/image/Image";
import subscriptionRepository from "@/modules/subscriptions/services/subscriptionRepository";

Vue.use(Croppa);
export default {
  name: "addCategories",
  created() {

  },
  components: {
    Image,
    BCard,
    BFormSelect,
    BRow,
    BCol,
    BLink,
    BFormGroup,
    BCardBody,
    BCardSubTitle,
    BCardTitle,
    BCardText,
    BImg,
    BFormRadio,
    BFormInput,
    BFormCheckbox,
    BForm,
    BButton,
    BFormFile,
    videoFormComponent,
  },
  data(){
    return {
      postData:{
        title: '',
        numberOfDevice: undefined,
        status: true,
        discountPercent: undefined,
        price: undefined,
        expireMonths: undefined
      }
    }
  },
  methods: {
    handleImageUpload(event) {
      this.imageFile = event.target.files[0]

      // console.log('handleCoverImageUpload')
      let reader = new FileReader()

      reader.addEventListener('load', function () {

        this.showImagePreView = true
        this.imagePreView = reader.result
        this.$emit('imageChanged', this.imageFile)

      }.bind(this), false)

      if (this.imageFile) {
        /*
          Ensure the file is an image file.
        */

        if (/\.(jpe?g|png|svg)$/i.test(this.imageFile.name)) {

          /*
            Fire the readAsDataURL method which will read the file in and
            upon completion fire a 'load' event which we will listen to and
            display the image in the preview.
          */

          reader.readAsDataURL(this.imageFile)
        }
      }

    },
  async  addSubscription(){

     if (this.postData.title  && this.postData.price && this.postData.expireMonths && this.postData.numberOfDevice){
         const {data} = await subscriptionRepository.create(this.postData);
         if (data.isSuccess){
           await Swal.fire({
             confirmButtonText: 'ok',
             title : 'موفقیت',
             html : 'عملیات با موفقیت انجام شد',
             icon: 'success'
           } );
           await this.$router.replace('/subscription/list')
         }else {
           await Swal.fire('هشدار', data.message, 'warning');
         }
       }else {
          await  Swal.fire('خطا' , ' نیاز است که فیلد های اجباری را پر کنید' , 'error')

       }





    },

  }
}
</script>

<style scoped>


.croppa-container {
  background-color: #c3c3c3;
  border: 2px solid grey;
  border-radius: 8px;
}

.croppa-container:hover {
  opacity: 1;
  background-color: #8ac9ef;
}

</style>
